module.exports = __webpack_public_path__ + "img/kx5600-4.bda02451.png";